import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { storeSession } from '../auth/cognito';
import { getMyProfile } from '../api/public';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const hash = window.location.hash.substring(1);
    const params = new URLSearchParams(hash);
    const idToken = params.get('id_token');

    if (!idToken) {
      navigate('/', { replace: true });
      return;
    }

    storeSession(idToken);

    // Check if user has paid — if not, send them to subscribe
    getMyProfile().then(profile => {
      if (!profile || profile.plan !== 'paid') {
        navigate('/subscribe', { replace: true });
      } else {
        navigate('/', { replace: true });
      }
    }).catch(() => {
      // On API error fall through to home; RequirePaid will gate protected routes
      navigate('/', { replace: true });
    });
  }, [navigate]);

  return (
    <div style={{
      minHeight: '100vh', background: '#f3f4f6',
      display: 'flex', alignItems: 'center', justifyContent: 'center',
    }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 40, marginBottom: 16 }}>🔐</div>
        <p style={{ color: '#6b7280', fontSize: 16 }}>Signing you in...</p>
      </div>
    </div>
  );
}
